import { render, staticRenderFns } from "./VisitorToStudyView.vue?vue&type=template&id=724f3588&scoped=true"
import script from "./VisitorToStudyView.vue?vue&type=script&lang=js"
export * from "./VisitorToStudyView.vue?vue&type=script&lang=js"
import style0 from "./VisitorToStudyView.vue?vue&type=style&index=0&id=724f3588&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724f3588",
  null
  
)

export default component.exports